import type { Destination, Language } from '../types'

export interface PlaceSearchResponse {
  candidates: Destination[]
  mode: 'live' | 'demo'
  notice?: string
}

export interface PlaceProvider {
  readonly name: string
  search(query: string, language: Language): Promise<PlaceSearchResponse>
}

export class PlaceProviderUnavailableError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'PlaceProviderUnavailableError'
  }
}
